import React, { useState, Fragment } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteBaseFuelRefill } from '../../../../actions';

const DeleteBaseFuelRefillButton = ({
  baseFuelRefillId,
  dispatchDeleteBaseFuelRefill,
}) => {
  const [showModal, setShowModal] = useState(false);

  const onClickDelete = () => {
    dispatchDeleteBaseFuelRefill({ baseFuelRefillId });
  };

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  return (
    <>
        <Button color="danger" onClick={openModal}>
          <i className="fa fa-trash-o" /> Eliminar
        </Button>
      <ConfirmationModal
        show={showModal}
        onClickConfirm={onClickDelete}
        onClickCancel={closeModal}
      />
    </>
  );
};

DeleteBaseFuelRefillButton.propTypes = {
  baseFuelRefillId: PropTypes.number.isRequired,
  dispatchDeleteBaseFuelRefill: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchDeleteBaseFuelRefill: deleteBaseFuelRefill,
};

export default connect(null, mapDispatchToProps)(DeleteBaseFuelRefillButton);
